import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { id: "decklist" }
const _hoisted_2 = { class: "decks" }
const _hoisted_3 = { class: "deck-top" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h1", { class: "deck-title" }, "持有卡牌", -1)
const _hoisted_5 = { class: "deck-options" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "deck-line" }, null, -1)
const _hoisted_7 = { class: "card-list-header" }
const _hoisted_8 = { class: "deck-title" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("hr", { class: "deck-line" }, null, -1)
const _hoisted_10 = { class: "card" }
const _hoisted_11 = { class: "card-info" }
const _hoisted_12 = { class: "card-name" }
const _hoisted_13 = { class: "card-sub" }
const _hoisted_14 = { class: "card-text" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "卡牌选取", -1)
const _hoisted_17 = { class: "box card-list-box" }
const _hoisted_18 = { class: "card-list-header" }
const _hoisted_19 = { class: "deck-title" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("hr", { class: "deck-line" }, null, -1)
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "info card-info" }
const _hoisted_23 = { class: "card-name" }
const _hoisted_24 = { class: "card-sub" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("h1", { class: "title" }, "打乱顺序", -1)
const _hoisted_26 = { class: "box random-list-box" }
const _hoisted_27 = { class: "card" }
const _hoisted_28 = { class: "info random-info" }
const _hoisted_29 = { class: "card-id" }
const _hoisted_30 = { class: "card-name" }
const _hoisted_31 = { class: "card-name" }

import {
  cardTypeListName,
  playerDeckList,
  deckList,
  cardDialogVisible,
  randomDialogVisible,
  deleteCardButton,
  addCardButton,
  addCard,
  allDeck,
  randomCardButton,
  initDeckList
} from "@/assets/ts/decklist";


export default /*#__PURE__*/_defineComponent({
  __name: 'DeckListView',
  setup(__props) {


initDeckList();

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("button", {
            class: "button get-button",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref(addCardButton) && _unref(addCardButton)(...args)))
          }, "卡牌选取"),
          _createElementVNode("button", {
            class: "button random-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_unref(randomCardButton) && _unref(randomCardButton)(...args)))
          }, "打乱卡牌顺序")
        ]),
        _hoisted_6
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(playerDeckList), (deck, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "card-list",
          key: index
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("h2", _hoisted_8, _toDisplayString(_unref(cardTypeListName)[index]) + " - 持有 " + _toDisplayString(deck.value.length) + " 张", 1),
            _hoisted_9
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deck.value, (card, index2) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-item",
              key: index2
            }, [
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_12, "- " + _toDisplayString(card.cardName) + " -", 1),
                    _createElementVNode("p", _hoisted_13, "- " + _toDisplayString(card.name) + " -", 1)
                  ]),
                  _createElementVNode("p", _hoisted_14, _toDisplayString(card.description), 1)
                ])
              ]),
              _createElementVNode("button", {
                class: "button delete-button",
                onClick: ($event: any) => (_unref(deleteCardButton)(card, index, index2))
              }, "删除", 8, _hoisted_15)
            ]))
          }), 128))
        ]))
      }), 128))
    ]),
    _createVNode(_component_el_dialog, {
      class: "dialog card-dialog",
      modelValue: _unref(cardDialogVisible),
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(cardDialogVisible) ? (cardDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "75.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(deckList), (deck, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "card-list",
              key: index
            }, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("h2", _hoisted_19, _toDisplayString(_unref(cardTypeListName)[index]) + " " + _toDisplayString(deck.value.length) + " 张", 1),
                _hoisted_20
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(deck.value, (card, index2) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "item card-item",
                  key: index2
                }, [
                  _createElementVNode("div", {
                    class: "card",
                    onClick: ($event: any) => (_unref(addCard)(card, index))
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_23, _toDisplayString(card.name), 1),
                        _createElementVNode("p", _hoisted_24, _toDisplayString(card.cardName), 1)
                      ])
                    ])
                  ], 8, _hoisted_21)
                ]))
              }), 128))
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button card-cancel card-close",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (cardDialogVisible.value = false))
        }, "取消")
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      class: "dialog random-dialog",
      modelValue: _unref(randomDialogVisible),
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(randomDialogVisible) ? (randomDialogVisible).value = $event : null)),
      "close-on-click-modal": false,
      width: "75.25rem",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _hoisted_25,
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allDeck), (card, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "item random-item",
              key: index
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("p", _hoisted_29, _toDisplayString(card.name), 1),
                  _createElementVNode("p", _hoisted_30, _toDisplayString(card.cardName), 1),
                  _createElementVNode("p", _hoisted_31, "- " + _toDisplayString((index + 1)) + " -", 1)
                ])
              ])
            ]))
          }), 128))
        ]),
        _createElementVNode("button", {
          type: "button",
          class: "button random-cancel",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (randomDialogVisible.value = false))
        }, "取消")
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})